import authInstance from 'config/axios.config';

export const dashboardServices = {

  getDashboardStats: async () => {

    const res = await authInstance.get(
      '/admin/stats/dashboard-stats'
    );

    return res.data;
  },

  getTopSellersByBookings: async (params) => {
    const response = await authInstance.get(
      '/admin/sellers/top-sellers-by-bookings',
      { params }
    );

    return response.data;
  },

  getCategoryWiseRevenue : async (params) => {
  const { data } = await authInstance.get(
    "/admin/stats/category-wise-earnings",
    {
      params,
    }
  );

  return data;
}


};


export default dashboardServices;